import { ListItem, ListItemButton, Typography, useTheme } from "@mui/material";
import { ChevronDown, ChevronRight } from "../../../icons";

type ItemOptionMbProps = {
  label?: string;
  isOpen?: boolean;
  children?: React.ReactNode;
  onClick: () => void;
};
export const ItemOptionMb = ({
  label,
  isOpen,
  children,
  onClick,
}: ItemOptionMbProps) => {
  const theme = useTheme();
  return (
    <ListItem disablePadding onClick={onClick}>
      <ListItemButton
        TouchRippleProps={{
          style: {
            color: theme.palette.primary[700],
          },
        }}
        sx={{
          display: "flex",
          alignItems: "center",
          paddingBlock: 3,
          gap: 2,
          m: 1,
        }}
      >
        {children}
        <Typography variant="subtitle2" flex={1} color="secondary">
          {label}
        </Typography>
        {isOpen ? (
          <ChevronDown sx={{ width: 14, height: 14 }} />
        ) : (
          <ChevronRight sx={{ width: 14, height: 14 }} />
        )}
      </ListItemButton>
    </ListItem>
  );
};
